import { Controller } from "@hotwired/stimulus"
import Cookies from "js-cookie";

export default class extends Controller {
  static values = {
    event: String,
    details: Object,
  }

  dismiss(event) {
    event.preventDefault()
    this.element.classList.add('c-flash--dismissed')
    // remove from DOM after animation
    setTimeout(() => this.element.remove(), 250)
  }

  connect() {
    setTimeout(() => this.sendEvent(), 200)
  }

  sendEvent() {
    if (this.eventIsAvailable()) {
      gtag('event', this.eventValue, this.detailsValue);

    } else if (this.eventInDev()) {
      console.log(`gtag('event', '${this.eventValue}', ${JSON.stringify(this.detailsValue)});`)
    }
  }

  eventIsAvailable() {
    return this.areCookiesAllowed() && this.eventValue !== "" && document.body.dataset.events === "true"
  }

  eventInDev() {
    return this.areCookiesAllowed() && this.eventValue !== "" && document.body.dataset.events === "development"
  }

  areCookiesAllowed() {
    return Cookies.get("allow_all_cookies") === "true";
  }
}
